<template>
  <nav v-if="info" class="menu-tabs" :aria-label="info.group.verbose_name">
    <router-link v-for="tab in info.tabs" :key="tab.id" :to="destination(tab)" class="tab" :class="{ current: isCurrent(tab) }"
                 :aria-current="isCurrent(tab) ? 'page' : null">
      <NavigationIcon :route="tab.frontend_route_url" />
      <span>{{ tab.verbose_name }}</span>
    </router-link>
  </nav>
</template>
<script>
import NavigationIcon from '../components/NavigationIcon/index.vue';
import { menuContainsRoute, menuDestination, tabsForRoute } from '../utils/adminNavigation';

// Children of a menu group marked display=tabs: the sidebar shows one link, the page shows these.
export default {
  name: 'MenuTabs',
  components: { NavigationIcon },
  computed: {
    info() { return tabsForRoute(this.$STORE.state.appConfig.menu, this.$route.path); },
  },
  methods: {
    destination: menuDestination,
    isCurrent(tab) { return menuContainsRoute(tab, this.$route.path); },
  },
};
</script>
<style scoped>
.menu-tabs { display: flex; gap: 2px; margin: -4px 0 20px; border-bottom: 1px solid var(--line-strong); overflow-x: auto; scrollbar-width: none; max-width: 100%; }
.menu-tabs::-webkit-scrollbar { display: none; }
.tab { position: relative; display: inline-flex; align-items: center; gap: 8px; min-height: 44px; padding: 6px 16px; color: var(--text-3); font-size: 13px; font-weight: 700; white-space: nowrap; text-decoration: none; transition: color .15s; }
.tab::after { content: ''; position: absolute; inset-inline: 12px; bottom: -1px; height: 3px; background: var(--pink-500); transform: scaleX(0) skewX(var(--slant)); transform-origin: right; transition: transform .3s var(--ease-out); }
.tab:hover { color: var(--text); }
.tab.current { color: var(--text); }
.tab.current::after, .tab:hover::after { transform: scaleX(1) skewX(var(--slant)); }
.tab:hover:not(.current)::after { background: var(--line-strong); }
.tab:focus-visible { outline: 2px solid var(--focus); outline-offset: -2px; }
.tab .navigation-icon { width: 18px; height: 18px; flex-basis: 18px; }
</style>
